import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
  FormsModule,
  FormControl,
} from '@angular/forms';
import { SettingsService } from '../settings/settings.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { CustomValidators } from 'ng2-validation';

@Component({
  selector: 'app-registro-user',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    MaterialModule,
    RouterModule,
  ],
  templateUrl: './registro-user.component.html',
  styleUrl: './registro-user.component.less',
})
export class RegistroUserComponent implements OnInit {
  valForm: FormGroup;
  disabledButton: boolean = false;
  hidePassword: boolean = true;
  hideConfirmPassword: boolean = true;
  role: any;
  showSpinner: boolean = false;

  verification_code: string = '';
  sub: any;
  showForm: boolean = true;
  spinner: boolean = false;

  constructor(
    fb: FormBuilder,
    public snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute,
    public settings: SettingsService,
    private change: ChangeDetectorRef
  ) {
    let password = new FormControl(
      '',
      Validators.compose([Validators.required, Validators.minLength(6)])
    );
    let confirmPassword = new FormControl(
      null,
      Validators.compose([
        Validators.required,
        CustomValidators.equalTo(password),
      ])
    );

    this.valForm = fb.group({
      password: password,
      confirmPassword: confirmPassword,
    });

    this.sub = this.route.params.subscribe((params: any) => {
      this.verification_code = params['id'];
    });
  }

  ngOnInit() {
    this.verify_code();
    this.settings.verify_out();
    this.change.detectChanges();
  }

  async verify_code() {
    this.showSpinner = true;
    try {
      const bd: any = await this.settings.get_query(
        1,
        `cliente-inversionista/recover-password/?verification_code=${this.verification_code}`,
        {},
        true
      );
      var body_data: any = bd._body;
      var data = body_data.success.info;

      switch (bd.status) {
        case 200:
          this.showForm = true;
          break;
        default:
          this.showForm = false;
          break;
      }
    } catch (error) {
      this.showForm = false;
    } finally {
      this.showSpinner = false;
    }
  }

  async submitForm($ev: any, value: any) {
    value["verification_code"]=this.verification_code;
    $ev.preventDefault();
    for (let c in this.valForm.controls) {
      this.valForm.controls[c].markAsTouched();
    }
    if (this.valForm.valid) {
      try {
        this.showSpinner = true;
        const bd: any = await this.settings.get_query(2, `/cliente-inversionista/set-password/`, value, true);
        var body_data: any =bd._body;
        var data = body_data.success.info;
        switch (bd.status) {
          case 200:
            this.showSpinner = false;
            this.router.navigate(['login']);
            this.snackBar.open(
              '¡Has creado tu contraseña con éxito! Ahora podrás volver a ingresar a tu cuenta.',
              'Aceptar',
              {
                duration: 5000,
                panelClass: 'simpli-snack',
              }
            );
          break;
          default:
            this.showSpinner = false;
            this.snackBar.open(
              'Hubo un error al crear tu contraseña. Por favor, intenta de nuevo.',
              'Aceptar',
              {
                duration: 5000,
                panelClass: 'simpli-snack-error',
              }
            );
          break;
        }
      } catch (bd: any) {
        this.showSpinner = false;
        this.snackBar.open(
          'Hubo un error al crear tu contraseña. Por favor, intenta de nuevo.',
          'Aceptar',
          {
            duration: 5000,
            panelClass: "simpli-snack",
          }
        );
      }
    }
  }

  async reapply(){
    this.spinner = true;
    try {
      const bd: any = await this.settings.get_query(1, `/cliente-inversionista/reapply-access/?verification_code=${this.verification_code}`, {}, true); 
      const body_data: any = bd._body;

      

      this.snackBar.open(
        'Hemos enviado un enlace con un código para que puedas crear tu contraseña. Revisa tu bandeja de entrada.',
        'Aceptar',
        { 
          duration: 5000, 
          panelClass: 'simpli-snack',
        }
      );
      this.router.navigate(['login']);

    } catch (error) {
      console.error('Error al enviar acceso:', error);
      this.snackBar.open(
        'Hubo un error al enviar el acceso. Por favor, intenta de nuevo.',
        'Aceptar',
        {
          duration: 5000,
          panelClass: 'simpli-snack',
        }
      );
    } finally {
      this.spinner = false;
    }
  }
  
}
